var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgOutfit = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 84,
    height: 84
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m33.542 44.3-.034.65h16.984l-.034-.65H33.542Zm-1.228 23.4.962-18.33a3.9 3.9 0 0 0 2.837-3.12h5.239v.65a.65.65 0 1 0 1.296 0v-.65h5.239a3.9 3.9 0 0 0 2.837 3.12l.962 18.33h-6.538l-2.505-16.335a.649.649 0 0 0-1.284-.01L38.852 67.7h-6.538ZM50.65 47.969l-.09-1.719h-1.35a2.604 2.604 0 0 0 1.44 1.719ZM34.789 46.25a2.604 2.604 0 0 1-1.44 1.719l.09-1.719h1.35Zm-2.526-2.326a.973.973 0 0 1 .971-.924h17.532c.517 0 .944.406.97.924L53 67.974A.974.974 0 0 1 52.028 69H44.87a.973.973 0 0 1-.96-.827L42 55.725l-1.91 12.448a.973.973 0 0 1-.96.827h-7.158c-.557 0-1-.468-.97-1.026l1.261-24.05ZM42 48.2a.65.65 0 0 1 .648.65v.65a.65.65 0 1 1-1.296 0v-.65c0-.359.29-.65.648-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.09 15 42 17.611 45.91 15l4.265 1.068a3.365 3.365 0 0 1 2.355 2.147l3.355 9.525c.19.537.143 1.129-.126 1.63l-4.345 8.084v2.525A2.02 2.02 0 0 1 49.397 42H34.603a2.02 2.02 0 0 1-2.017-2.021v-2.525L28.24 29.37a2.025 2.025 0 0 1-.126-1.63l3.355-9.525a3.365 3.365 0 0 1 2.355-2.147L38.091 15Zm-4.16 22.114V23.137a.673.673 0 1 0-1.344 0v11.475l-3.16-5.88a.675.675 0 0 1-.043-.544l3.356-9.524a2.019 2.019 0 0 1 1.413-1.289l3.688-.923L42 19.23l4.16-2.778 3.688.923a2.019 2.019 0 0 1 1.413 1.289l3.356 9.524a.676.676 0 0 1-.042.544l-3.16 5.88V23.136a.673.673 0 1 0-1.346 0v16.842a.673.673 0 0 1-.672.675H34.603a.673.673 0 0 1-.672-.674v-2.865Z"
  }))));
};
export { SvgOutfit as ReactComponent };